import React, { useState } from 'react';
import SearchLineIcon from 'remixicon-react/SearchLineIcon';

import { TextInput } from '../forms/text-input';
import { useFormSearchRadioContext } from '../forms/form';
import { RadioToggle } from '../controlled-inputs/radio-toggle';

export interface SearchRadioProps {
  name: string;
  label?: string;
  placeholder?: string;
  options: string[];
  showOther?: boolean;
}
interface FormValues {
  [key: string]: string;
}

export const SearchWithRadioButton: React.FC<SearchRadioProps> = ({
  name,
  label = '',
  placeholder = 'Search',
  options,
  showOther,
}) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [isShowCheckbox, setShowCheckBox] = useState(false);
  const { values, setFieldValue } = useFormSearchRadioContext<FormValues>();

  const handleToggleChange = (option: string) => {
    setFieldValue(name, option === values[name] ? '' : option);
    setShowCheckBox(false);
  };

  return (
    <div className="flex w-full flex-col gap-6">
      <div>
        {label && <h1 className="text-body-1 font-normal">{label}</h1>}
        <div className="border-grey-200 flex items-center gap-x-2 rounded-[4px] border py-[10px] px-3">
          <input
            type="text"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="flex-1 bg-transparent focus:outline-none"
          />
          <SearchLineIcon className="text-grey-600" size={20} />
        </div>
      </div>
      <div className="flex flex-col gap-4">
        {options
          .filter((option) => option.toLowerCase().includes(searchTerm.toLowerCase()))
          .map((option, index) => (
            <div className="flex items-center gap-3" key={index}>
              <RadioToggle
                label={option}
                name={option}
                checked={values[name] === option}
                onChange={() => handleToggleChange(option)}
              />
            </div>
          ))}
        {showOther && (
          <div className="flex flex-col gap-3">
            <RadioToggle
              label={'other'}
              name={'other'}
              checked={isShowCheckbox}
              onClick={() => {
                setShowCheckBox(true);
                setFieldValue(name, '');
              }}
            />
            {isShowCheckbox && (
              <div className="pl-7">
                <TextInput name={name} label={false} placeholder="Please Specify" />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
